// Entry point for JiT compilation.
declare var System: any;

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { SSPLoginModule } from '../../Login/login.module';

platformBrowserDynamic().bootstrapModule(SSPLoginModule).catch(err => console.log(err));;